export default function ConceptTag({ className = "", ...props }) {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border border-rp-accent/40 bg-black/50 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.18em] text-rp-accent backdrop-blur-md ${className}`}
      data-testid="concept-tag"
      {...props}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-rp-accent" />
      Concept Visualization
    </span>
  );
}
